import {Component, Input, ViewChild, ElementRef, HostListener, AfterViewInit, ViewChildren} from '@angular/core';
import {fromEvent} from 'rxjs';
import { map, tap, switchMap, takeUntil, finalize} from 'rxjs/operators';
@Component({
  selector: 'drawable-canvas',
  standalone: true,
  template: `<canvas #canvas [style.border]="'1px solid black'"width="500" height="200"></canvas>`,
})
export class DrawableCanvasComponent implements AfterViewInit {
  @ViewChild('canvas')
  private canvas: ElementRef = {} as ElementRef
  ctx: CanvasRenderingContext2D | null = null
  paint = false
  coord = {x:0, y:0}
  ngAfterViewInit(){
    if(this.canvas.nativeElement != undefined) {
      this.ctx = this.canvas.nativeElement.getContext("2d")
      this.canvas.nativeElement.addEventListener("mousedown", this.startPainting)
      this.canvas.nativeElement.addEventListener("mouseup", this.stopPainting)
      this.canvas.nativeElement.addEventListener("mousemove", this.sketch)
    }
  }
  getPosition(event: MouseEvent) {
    this.coord.x = event.clientX - this.canvas.nativeElement.offsetLeft
    this.coord.y = event.clientY - this.canvas.nativeElement.offsetTop
  }
  startPainting(event: MouseEvent){
    this.paint = true
    if(this.canvas.nativeElement != undefined) {
      this.coord.x = event.clientX - this.canvas.nativeElement.offsetLeft
      this.coord.y = event.clientY - this.canvas.nativeElement.offsetTop
    }
  }
  stopPainting(event: MouseEvent) {
    this.paint = false
  }
  sketch(event: MouseEvent) {
    if(!this.paint) return;
    if(this.ctx != null) {
      this.ctx.beginPath()
      this.ctx.lineWidth = 3
      this.ctx.lineCap = 'round'
      this.ctx.strokeStyle = 'black'
      this.ctx.moveTo(this.coord.x, this.coord.y)
      this.getPosition(event)
      this.ctx.lineTo(this.coord.x, this.coord.y)
      this.ctx.stroke()
    }
  }
}
